import { getImageUrl } from '@/lib/image-url';

// Type pour les points cliquables sur le plan
export type Hotspot = {
  id: string;
  x: number; // Position en pourcentage (0-100)
  y: number; // Position en pourcentage (0-100)
  roomId: string;
  label: string;
  hoverImage?: string; // Image à afficher au survol
};

// Points cliquables sur l'image du plan
export const hotspots: Hotspot[] = [
  {
    id: "hotspot-1",
    x: 20,
    y: 80,
    roomId: "chambre-1",
    label: "Suite parentale",
    hoverImage: getImageUrl("hotspotMap/plan-vue_de_haut-maison-ty-gwennili-suite.webp")
  },
  {
    id: "hotspot-2",
    x: 35,
    y: 25,
    roomId: "chambre-2",
    label: "Chambre accès terrasse",
    hoverImage: getImageUrl("hotspotMap/plan-vue_de_haut-maison-ty-gwennili-chambre-terrasse.webp")
  },
  {
    id: "hotspot-3",
    x: 16,
    y: 25,
    roomId: "chambre-3",
    label: "Chambre enfants",
    hoverImage: getImageUrl("hotspotMap/plan-vue_de_haut-maison-ty-gwennili-chambre-enfants.webp")
  },
  {
    id: "hotspot-4",
    x: 45,
    y: 60,
    roomId: "salon",
    label: "Salon",
    hoverImage: getImageUrl("hotspotMap/plan-vue_de_haut-maison-ty-gwennili-salon.webp")
  },
  {
    id: "hotspot-5",
    x: 70,
    y: 70,
    roomId: "cuisine",
    label: "Cuisine",
    hoverImage: getImageUrl("hotspotMap/plan-vue_de_haut-maison-ty-gwennili-cuisine.webp")
  },
  {
    id: "hotspot-6",
    x: 16,
    y: 47,
    roomId: "salle-de-bain",
    label: "Salle de bain",
    hoverImage: getImageUrl("hotspotMap/plan-vue_de_haut-maison-ty-gwennili-salle-de-bain.webp")
  },
  {
    id: "hotspot-7",
    x: 65,
    y: 25,
    roomId: "terrasse",
    label: "Terrasse",
    hoverImage: getImageUrl("hotspotMap/plan-vue_de_haut-maison-ty-gwennili-terrasse.webp")
  }
];
